<template>
  <div class="ele-body">
    <el-card shadow="never">
      <!-- 搜索表单 -->
      <el-form :model="table.where" label-width="77px" class="ele-form-search" @keyup.enter.native="$refs.table.reload()" @submit.native.prevent>
        <el-row :gutter="15">
          <el-col :md="7" :sm="12">
            <el-form-item label="登录日期:">
              <el-date-picker
                v-model="daterange"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                class="ele-fluid"
                @change="onDateRangeChoose"
              />
            </el-form-item>
          </el-col>
          <el-col :md="8" :sm="12">
            <div class="ele-form-actions">
              <el-button type="primary" @click="$refs.table.reload()" icon="el-icon-search" class="ele-btn-icon">查询 </el-button>
              <el-button @click="(table.where = {}) && $refs.table.reload()">重置</el-button>
              <el-button @click="exportData" type="primary" icon="el-icon-download" class="ele-btn-icon">导出 </el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <!-- 数据表格 -->
      <ele-data-table ref="table" :config="table" :choose.sync="choose" highlight-current-row>
        <template #default="{ index }">
          <el-table-column type="selection" width="45" align="center" fixed="left" />
          <el-table-column type="index" :index="index" width="45" align="center" fixed="left" show-overflow-tooltip />
          <el-table-column prop="lostName" label="丢失物品" sortable="custom" show-overflow-tooltip min-width="110" />
          <el-table-column prop="timePlace" label="丢失地点" sortable="custom" show-overflow-tooltip min-width="110" />
          <el-table-column prop="discoverer" label="发现人" sortable="custom" show-overflow-tooltip min-width="110" />
          <el-table-column prop="address" label="领取地点" sortable="custom" show-overflow-tooltip min-width="110" />
          <el-table-column prop="teacherName" label="发布教师" sortable="custom" show-overflow-tooltip min-width="110" />
          <el-table-column prop="mobile" label="手机号" sortable="custom" show-overflow-tooltip min-width="110" />
          <el-table-column label="推送范围" align="center" show-overflow-tooltip width="100">
            <template #default="{ row }">
              <label>{{
                row.pushParent == 1 && row.pushTeacher == 1
                  ? '家长、教师'
                  : row.pushParent == 1 && row.pushTeacher == 0
                  ? '家长'
                  : row.pushParent == 0 && row.pushTeacher == 1
                  ? '教师'
                  : ''
              }}</label>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="创建时间" show-overflow-tooltip min-width="110" />
        </template>
      </ele-data-table>
    </el-card>
  </div>
</template>

<script>
  import { exportSchoolLostList } from '@/config/api';

  export default {
    name: 'Lost',
    data() {
      return {
        table: {
          // 表格配置
          url: '/school/lost/getSchoolLostList',
          where: {
            startDate: this.formatDate(new Date()),
            overDate: this.formatDate(new Date()),
          },
          parseData(res) {
            if (res.resCode == 200) res.code = 0;
            res.count = res.data.total;
            res.data = res.data.records;
            return res;
          },
        },
        choose: [], // 表格选中数据
        daterange: [new Date(), new Date()],
      };
    },
    methods: {
      formatDate(date) {
        let y = date.getFullYear();
        let m = date.getMonth() + 1;
        let d = date.getDate();
        let hh = date.getHours();
        let mm = date.getMinutes();
        // let ss = date.getSeconds();
        if (m < 10) {
          m = 0 + '' + m;
        }
        if (d < 10) {
          d = 0 + '' + d;
        }
        if (hh < 10) {
          hh = 0 + '' + hh;
        }
        if (mm < 10) {
          mm = 0 + '' + mm;
        }
        // if (ss < 10) {
        //   ss = 0 + '' + ss;
        // }
        return y + '-' + m + '-' + d; //格式可以在这调整
      },
      /* 日期选择改变回调 */
      onDateRangeChoose() {
        // console.log(this.daterange);
        if (this.daterange) {
          this.table.where.startDate = this.daterange[0];
          this.table.where.overDate = this.daterange[1];
        } else {
          this.table.where.startDate = null;
          this.table.where.overDate = null;
        }
      },
      // 导出数据
      exportData() {
        if (this.daterange) {
          let data = {
            startDate: this.daterange[0],
            overDate: this.daterange[1],
          };
          exportSchoolLostList(data).then((res) => {
            let blob = new Blob([res.data], {
              type: 'application/octet-stream',
            });
            let objectUrl = URL.createObjectURL(blob);
            // console.log(objectUrl)
            let link = document.createElement('a');
            link.style.display = 'none';
            link.href = objectUrl;
            let filename = window.decodeURI(res.headers['content-disposition'].split('=')[1], 'UTF-8');
            // console.log(res.headers)
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            // console.log(link);
            link.click();
            document.body.removeChild(link); // 下载完成移除元素
            window.URL.revokeObjectURL(objectUrl); // 释放掉blob对象
          });
        }
      },
    },
  };
</script>

<style scoped></style>
